var _path, _polygon, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _rect4, _path6, _path7, _path8, _polygon2, _polygon3, _polygon4, _polygon5, _path9, _path10, _polygon6, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPaloalto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    "data-name": "All Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_paloalto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.15,61.29c-4.52,0-9.21,1.23-15,4.34l3.23,8c5-2.82,9.21-4.05,12.26-4.05,3.47,0,5,1.29,5,3v.12c0,1.17-.94,1.82-3.22,2l-4,.41c-10,1.06-14.09,5.4-14.09,11.39v.41c0,5.7,4.7,10.16,11.33,10.16A12.52,12.52,0,0,0,170.1,92l.75,4.51h9V76c0-9.68-5.58-14.73-15.74-14.73m-.88,28c-3.34,0-4.93-1.29-4.93-3.29v-.11c0-1.77,1-3.06,4.64-3.59l1.59-.23a12.4,12.4,0,0,0,5-1.54v2.6c0,3.93-2.46,6.16-6.34,6.16",
    fill: "#231f20"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "79.15 61.52 67.58 49.96 56.02 61.52 61.77 67.28 32.77 96.28 44.34 107.84 55.9 96.28 50.15 90.52 79.15 61.52",
    fill: "#ef4e23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.23,
    y: 62.06,
    width: 41.01,
    height: 16.36,
    transform: "translate(-39.2 45.84) rotate(-45)",
    fill: "#ef4e23"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.68,
    y: 79.38,
    width: 41.01,
    height: 16.36,
    transform: "translate(-39.6 79.52) rotate(-45)",
    fill: "#ef4e23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185.76,
    y: 49.55,
    width: 10.27,
    height: 46.96,
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131,61.29a12,12,0,0,0-10.48,5.3l-.79-4.71h-9v46.37H121V92.18c1.95,3,5.65,4.92,10,4.92,8.22,0,14.92-7.28,14.92-17.32V78.61c0-10-6.7-17.32-14.92-17.32m4.35,18.2c0,5.28-2.76,9.1-7.34,9.1s-7.34-3.82-7.34-9.1V78.9c0-5.28,2.76-9.1,7.34-9.1s7.34,3.82,7.34,9.1Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.63,61.29c-10.5,0-17.9,7.28-17.9,17.32v1.17c0,10,7.4,17.32,17.9,17.32s17.91-7.28,17.91-17.32V78.61c0-10-7.4-17.32-17.91-17.32M342,79.49c0,5.28-2.76,9.1-7.34,9.1s-7.33-3.82-7.33-9.1V78.9c0-5.28,2.76-9.1,7.33-9.1S342,73.62,342,78.9Z",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.23,63.4v-.17c0-1-.77-1.71-2.12-1.71h-2.35v5.4h1.12V65.1h1.24l.93,1.82h1.23l-1.14-2.13a1.42,1.42,0,0,0,1.09-1.39m-3.35-.88h1.23c.71,0,1,.24,1,.76v.06c0,.47-.29.77-1,.77h-1.23Z",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.88,58.65a5.58,5.58,0,1,0,5.57,5.57,5.46,5.46,0,0,0-5.57-5.57m0,10.39a4.82,4.82,0,1,1,4.75-4.82A4.62,4.62,0,0,1,359.88,69",
    fill: "#231f20"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 276.22,
    y: 49.55,
    width: 10.27,
    height: 46.96,
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.75,88.59c-3,0-4.11-1.47-4.11-4.64V69.8h12.09V61.88H302.64V54l-10.27,1.53V85c0,8,4.11,12.15,12.32,12.15A24.39,24.39,0,0,0,316.14,94l-2.93-7.28a16.48,16.48,0,0,1-6.46,1.88",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.62,61.29c-4.52,0-9.22,1.23-15,4.34l3.23,8c5.05-2.82,9.22-4.05,12.27-4.05,3.46,0,5,1.29,5,3v.12c0,1.17-.94,1.82-3.23,2l-4,.41c-10,1.06-14.09,5.4-14.09,11.39v.41c0,5.7,4.7,10.16,11.33,10.16A12.53,12.53,0,0,0,260.57,92l.74,4.51h9V76c0-9.68-5.57-14.73-15.73-14.73m-.88,28c-3.35,0-4.93-1.29-4.93-3.29v-.11c0-1.77,1-3.06,4.63-3.59l1.59-.23a12.46,12.46,0,0,0,5-1.54v2.6c0,3.93-2.47,6.16-6.34,6.16",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.52,61.29c-10.51,0-17.91,7.28-17.91,17.32v1.17c0,10,7.4,17.32,17.91,17.32s17.9-7.28,17.9-17.32V78.61c0-10-7.4-17.32-17.9-17.32m7.33,18.2c0,5.28-2.76,9.1-7.33,9.1s-7.34-3.82-7.34-9.1V78.9c0-5.28,2.76-9.1,7.34-9.1s7.33,3.82,7.33,9.1Z",
    fill: "#231f20"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.57 104.84 263.2 104.84 266.83 109.63 266.87 109.63 266.87 104.84 269.28 104.84 269.28 113.29 266.74 113.29 263.02 108.38 262.98 108.38 262.98 113.29 260.57 113.29 260.57 104.84",
    fill: "#231f20"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.49 104.84 279.88 104.84 279.98 106.89 275.02 106.89 275.02 108.05 278.92 108.05 278.92 109.92 275.02 109.92 275.02 111.24 280.12 111.24 280.03 113.29 272.49 113.29 272.49 104.84",
    fill: "#231f20"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.27 107.01 282.31 107.01 282.4 104.84 290.67 104.84 290.77 107.01 287.81 107.01 287.81 113.29 285.27 113.29 285.27 107.01",
    fill: "#231f20"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.81 104.84 295.51 104.84 296.89 110.71 297.02 110.71 298.81 104.84 301.29 104.84 303.04 110.71 303.17 110.71 304.52 104.84 307.11 104.84 304.88 113.29 301.56 113.29 300.02 108.19 299.95 108.19 298.38 113.29 295.04 113.29 292.81 104.84",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309,109.06c0-2.75,1.87-4.47,4.83-4.47s4.83,1.72,4.83,4.47-1.87,4.48-4.83,4.48-4.83-1.72-4.83-4.48m7.14,0a2.31,2.31,0,1,0-2.32,2.33,2.13,2.13,0,0,0,2.32-2.33",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M321.36,104.84h4.93c2.24,0,3.34,1.06,3.34,3a2.62,2.62,0,0,1-1.64,2.7l2,2.72h-2.87l-1.56-2.22H323.9v2.22h-2.54Zm4.6,4.25a1,1,0,0,0,1.15-1.11c0-.64-.3-1.1-1.15-1.1H323.9v2.21Z",
    fill: "#231f20"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.93 104.84 335.46 104.84 335.46 107.95 336.5 107.95 338.97 104.84 341.82 104.84 341.83 104.85 338.6 108.89 342.02 113.28 342 113.29 339.05 113.29 336.49 110.04 335.46 110.04 335.46 113.29 332.93 113.29 332.93 104.84",
    fill: "#231f20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M344,112.73v-2.31h0a9.06,9.06,0,0,0,4,1.06c.9,0,1.36-.22,1.36-.64s-.3-.53-2.11-.82c-2-.32-3.3-.91-3.3-2.61s1.39-2.8,4.11-2.8a8.41,8.41,0,0,1,3.27.68v2.29h0a7.45,7.45,0,0,0-3.45-.94c-1,0-1.35.23-1.35.62s.59.54,2.08.79c2,.34,3.29.9,3.29,2.68,0,1.39-1,2.78-4,2.78a9.94,9.94,0,0,1-3.87-.79",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaloalto);
export default __webpack_public_path__ + "static/media/logo_paloalto.8d1c554498ac51451e38d7f29106098e.svg";
export { ForwardRef as ReactComponent };